import React from 'react';

const LocalStorageContext = React.createContext(null);

export default LocalStorageContext;
